import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { DashboardQuerySorterConfig } from 'fa-kt.types';
import { DashboardService } from '../service';

@Component({
  selector: 'fa-kt-dashboard-sorter',
  templateUrl: './dashboard-sorter.component.html',
  styleUrls: ['./dashboard-sorter.component.css'],
})
export class DashboardSorterComponent {
  public DashboardSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public dashboard: DashboardService,
  ) {
    this.DashboardSorterConfig = DashboardQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
